import React from 'react';
import { Box, type Palette } from '@mui/material';
import { VerticalDivider } from '@europrocurement/flexy-components';
import type { DossierOpenSearch } from '@europrocurement/l2d-domain';
import type { UpdateDossierPayload } from '@europrocurement/l2d-modules/modules/Dossiers/types/UpdateDossierPayload';
import { ClientOpereInfo } from './ClientOpereInfo';
import { ClientReference } from './ClientReference';

interface MainInfoSectionProps {
    clientOpere: {
        raisonSociale: string;
        siren?: string;
        urlToSocieteDotCom?: string;
    };
    dossier: {
        societeRef?: string;
    };
    dossierSelected?: DossierOpenSearch;
    palette: Palette;
    onUpdate: (payload: UpdateDossierPayload) => void;
    onRefresh?: () => void;
}

export const MainInfoSection: React.FunctionComponent<MainInfoSectionProps> = function ({
    clientOpere,
    dossier,
    dossierSelected,
    palette,
    onUpdate,
    onRefresh,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <ClientOpereInfo
                clientOpere={clientOpere}
                palette={palette}
            />
            <VerticalDivider
                sx={{
                    height: '25px',
                    marginLeft: '5px',
                    marginRight: '5px',
                }}
            />
            <ClientReference
                societeRef={dossier.societeRef}
                dossierSelected={dossierSelected}
                onUpdate={onUpdate}
                onRefresh={onRefresh}
            />
        </Box>
    );
};
